import React, { useRef, useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useGetPartyLeBuTree } from "../../../../hooks/services/sBook/useOfParty"
import Picker from '../../../Common/Picker';
import CValidator from '../../../Common/CValidator';
import Message from '../../../Common/Message';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import { Checkbox } from '@fluentui/react';
import CLabel from '../../../Common/CLabel';
import { isNullUndefined } from '../../../../common/Helpers';

const SidePanelPartys = (props) => {
    const { t } = useTranslation();

    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;

    const inputParam_BookId = props.bookId;

    const inputParam_SelectedLeBuList = props.selectedLeBuList !== null ? props.selectedLeBuList : [];
    const inputParam_SetterSelectedLeBuList = props.setterSelectedLeBuList;

    const inputParam_RelatedConceptHasPartys = props.relatedConceptHasPartys !== null && props.relatedConceptHasPartys !== undefined ? props.relatedConceptHasPartys : false;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [selectedLeBu, setSelectedLeBu] = useState(null);
    const [managerParty, setManagerParty] = useState(false);
    const [contractorParty, setContractorParty] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const [lebuTreeList, setLebuTreeList] = useState(null);
    useGetPartyLeBuTree(inputParam_BookId, lebuTreeList, inputParam_SelectedLeBuList, setLebuTreeList)

    const [isInvalidForm, setIsInvalidForm] = useState(false);

    const canSelectManagerParty = inputParam_RelatedConceptHasPartys === false &&
        isNullUndefined(inputParam_SelectedLeBuList.find(x => x.manager === true));

    const canSelectContractorParty = inputParam_RelatedConceptHasPartys === false &&
        isNullUndefined(inputParam_SelectedLeBuList.find(x => x.counterParty === true));

    const hasPartyTypeOptions = canSelectManagerParty || canSelectContractorParty;

    const getCurrentPartyTypes = (managerValue = managerParty, contractorValue = contractorParty) => {
        const partyTypes = {};

        if (canSelectManagerParty) {
            partyTypes.manager = !!managerValue;
        }

        if (canSelectContractorParty) {
            partyTypes.counterParty = !!contractorValue;
        }

        return partyTypes;
    };

    const applyPartyTypesToItems = (items, partyTypes) => {
        if (!Array.isArray(items)) {
            return [];
        }

        return items.map(item => {
            const nextItem = { ...item };

            if (Array.isArray(nextItem.children) && nextItem.children.length > 0) {
                nextItem.children = applyPartyTypesToItems(nextItem.children, partyTypes);
            }

            Object.keys(partyTypes).forEach(propertyName => {
                nextItem[propertyName] = partyTypes[propertyName];
            });

            return nextItem;
        });
    };

    const normalizeManagerName = (items) => {
        if (!Array.isArray(items)) {
            return [];
        }

        return items.map(item => {
            const nextItem = { ...item };

            if (nextItem.manager === true) {
                nextItem.name = 'Mandante';
            }

            if (Array.isArray(nextItem.children) && nextItem.children.length > 0) {
                nextItem.children = normalizeManagerName(nextItem.children);
            }

            return nextItem;
        });
    };

    const recurrentCheckItems = (items, currentNode) => {
        if (!Array.isArray(items)) {
            return [];
        }

        return items.map(x => {
            const nextItem = { ...x };

            if (Array.isArray(nextItem.children) && nextItem.children.length > 0) {
                nextItem.children = recurrentCheckItems(nextItem.children, currentNode);
            }

            if (nextItem.id === currentNode.id) {
                nextItem.checked = currentNode.checked;
            }

            return nextItem;
        });
    };

    const isPartySelectionValid = (items) => {
        return Array.isArray(items) && items.length > 0;
    };

    const isPartyTypeSelectionValid = () => {
        if (inputParam_RelatedConceptHasPartys === true || hasPartyTypeOptions === false) {
            return true;
        }

        return (
            (canSelectManagerParty && managerParty === true) ||
            (canSelectContractorParty && contractorParty === true)
        );
    };

    const resetPanelState = () => {
        setShowMessage(false);
        setMessage(null);
        setMessageType(null);
        setIsInvalidForm(false);
        setManagerParty(false);
        setContractorParty(false);
        setSelectedLeBu(null);
        setLebuTreeList(null);
        setIsOpen(false);
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        resetPanelState();
        inputParam_SetterIsPanelOpen(false);
    };

    const onSelectPartys = () => {
        const selectedItemsWithPartyTypes = applyPartyTypesToItems(selectedLeBu, getCurrentPartyTypes());
        const isValidForm = isPartySelectionValid(selectedItemsWithPartyTypes) && isPartyTypeSelectionValid();

        if (isValidForm) {
            const itemsToAdd = normalizeManagerName(selectedItemsWithPartyTypes);

            inputParam_SetterSelectedLeBuList(itemsToAdd, inputParam_SelectedLeBuList);
            setShowMessage(true);
            setIsInvalidForm(false);
            onDismissPanel();
        }
        else {
            setShowMessage(true);
            setMessageType("warning");
            setIsInvalidForm(true);
            setMessage(t('data-lang-msg-requiredpartys'));
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onChangeParty = (currentNode, selectedNodes) => {
        const selectedItemsWithPartyTypes = applyPartyTypesToItems(selectedNodes, getCurrentPartyTypes());

        setSelectedLeBu(selectedItemsWithPartyTypes);
        setLebuTreeList(prevItems => recurrentCheckItems(prevItems, currentNode));

        if (isPartySelectionValid(selectedItemsWithPartyTypes)) {
            setIsInvalidForm(false);
            setShowMessage(false);
        }
    };

    const onCheckboxPartyChanged = (ev, checked, setter, propertyName) => {
        const checkedValue = !!checked;

        setter(checkedValue);

        setSelectedLeBu(prevItems => {
            return applyPartyTypesToItems(prevItems, {
                [propertyName]: checkedValue
            });
        });

        if (checkedValue === true) {
            setIsInvalidForm(false);
            setShowMessage(false);
        }
    };

    const handleFocus = () => {
        setIsOpen(true);
    };

    const handleBlur = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.relatedTarget)) {
            setIsOpen(false);
        }
    };

    const onRenderFooterContent = () => {
        return <div>
            <PrimaryButton onClick={onSelectPartys} styles={_global_buttonStyles}>{t('data-lang-btn-add')}</PrimaryButton>
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div>
    }

    return (
        <div>
            <Panel
                isOpen={inputParam_IsPanelOpen}
                isLightDismiss={true}
                onLightDismissClick={showDialog}
                onDismiss={onDismissPanel}
                headerText={t('data-lang-lbl-selectpartys')}
                closeButtonAriaLabel={t('data-lang-btn-close')}
                isFooterAtBottom={true}
                onRenderFooterContent={onRenderFooterContent}
                customWidth={PanelType.medium}
                type={PanelType.medium}
            >
                <Row style={{ height: "100px" }} className="pt-3">
                    <Col ref={dropdownRef} onFocus={handleFocus} onBlur={handleBlur} tabIndex={-1}>
                        <Picker
                            data={lebuTreeList !== null ? lebuTreeList : []}
                            mode="hierarchical"
                            className="dropdown-checkbox"
                            isInValid={isInvalidForm}
                            texts={{ placeholder: t('data-lang-lbl-chooses') }}
                            onChange={onChangeParty}
                            labelText={t('data-lang-lbl-partys')}
                            showDropdown={isOpen}
                        />
                        <CValidator isInValid={isInvalidForm} />
                    </Col>
                </Row>
                {
                    inputParam_RelatedConceptHasPartys === false &&
                    <Row style={{ height: "100px" }} className="pt-3">
                        <Col>
                            {
                                hasPartyTypeOptions &&
                                <CLabel labelText={'Tipo de parte'} />
                            }
                            {
                                canSelectManagerParty &&
                                <Checkbox className='p-1' label={t('data-lang-lbl-administrator')} checked={managerParty} onChange={(ev, checked) => onCheckboxPartyChanged(ev, checked, setManagerParty, 'manager')} />
                            }
                            {
                                canSelectContractorParty &&
                                <Checkbox className='p-1' label={t('data-lang-lbl-contractor')} checked={contractorParty} onChange={(ev, checked) => onCheckboxPartyChanged(ev, checked, setContractorParty, 'counterParty')} />
                            }
                            <CValidator isInValid={isInvalidForm && hasPartyTypeOptions && !isPartyTypeSelectionValid()} />
                        </Col>
                    </Row>
                }
                <Row className="pt-3 mx-auto">
                    <Col className="message-verybottom-panel-medium">
                        <Message width="96%" message={message} display={showMessage === null ? false : showMessage} messageType={messageType} setterShowMessage={setShowMessage} />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelPartys;
